import { useState, useEffect } from 'react';
import { debounce } from 'throttle-debounce';

/**
 * Hook that triggers when the user has scrolled a certain percentage of the viewport.
 * @param {number} percentage - The scroll percentage to trigger the effect.
 */
export function useHasScrolledPercentage(percentage = 50): boolean {
    const [hasScrolled, setHasScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = debounce(200, false, () => {
            const { scrollHeight, clientHeight } = document.documentElement;
            const scrollPosition = window.scrollY;
            const scrollPercentage = (scrollPosition / (scrollHeight - clientHeight)) * 100;

            if (scrollPercentage >= percentage) {
                setHasScrolled(true);
            }
        });

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [percentage]);

    return hasScrolled;
}
